import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase/config";

function userDocRef(uid) {
  return doc(db, "usuarios", uid);
}

function configDocRef(uid) {
  return doc(db, "usuarios", uid, "config", "app");
}

function produtosColRef(uid) {
  return collection(db, "usuarios", uid, "produtos");
}

function movimentacoesColRef(uid) {
  return collection(db, "usuarios", uid, "movimentacoes");
}

function vendasColRef(uid) {
  return collection(db, "usuarios", uid, "vendas");
}

function receitasColRef(uid) {
  return collection(db, "usuarios", uid, "receitas");
}

function receitaDocRef(uid, receitaId) {
  return doc(db, "usuarios", uid, "receitas", receitaId);
}

function produtoDocRef(uid, produtoId) {
  return doc(db, "usuarios", uid, "produtos", produtoId);
}

export async function buscarConfiguracaoApp(uid) {
  const snap = await getDoc(configDocRef(uid));

  if (!snap.exists()) {
    return {
      nomeNegocio: "Invexa Food",
      alertaPadrao: 12,
      moeda: "BRL",
    };
  }

  return snap.data();
}

export async function salvarConfiguracaoApp(uid, config) {
  await setDoc(
    configDocRef(uid),
    {
      nomeNegocio: config.nomeNegocio || "Invexa Food",
      alertaPadrao: Number(config.alertaPadrao || 12),
      moeda: "BRL",
      atualizadoEm: new Date().toISOString(),
    },
    { merge: true }
  );
}

export async function garantirUsuario(uid) {
  await setDoc(
    userDocRef(uid),
    {
      atualizadoEm: new Date().toISOString(),
    },
    { merge: true }
  );
}

export function ouvirProdutos(uid, callback, onError) {
  return onSnapshot(
    produtosColRef(uid),
    (snapshot) => {
      const lista = snapshot.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));
      callback(lista);
    },
    onError
  );
}

export function ouvirMovimentacoes(uid, callback, onError) {
  return onSnapshot(
    movimentacoesColRef(uid),
    (snapshot) => {
      const lista = snapshot.docs
        .map((item) => ({
          id: item.id,
          ...item.data(),
        }))
        .sort(
          (a, b) =>
            new Date(b.dataCompleta || 0) - new Date(a.dataCompleta || 0)
        );

      callback(lista);
    },
    onError
  );
}

export function ouvirVendas(uid, callback, onError) {
  return onSnapshot(
    vendasColRef(uid),
    (snapshot) => {
      const lista = snapshot.docs
        .map((item) => ({
          id: item.id,
          ...item.data(),
        }))
        .sort(
          (a, b) =>
            new Date(b.dataCompleta || 0) - new Date(a.dataCompleta || 0)
        );

      callback(lista);
    },
    onError
  );
}

export function ouvirReceitas(uid, callback, onError) {
  return onSnapshot(
    receitasColRef(uid),
    (snapshot) => {
      const lista = snapshot.docs
        .map((item) => ({
          id: item.id,
          ...item.data(),
        }))
        .sort(
          (a, b) =>
            new Date(b.criadoEm || 0) - new Date(a.criadoEm || 0)
        );

      callback(lista);
    },
    onError
  );
}

export async function adicionarProduto(uid, produto) {
  const agora = new Date().toISOString();

  await addDoc(produtosColRef(uid), {
    nome: produto.nome,
    categoria: produto.categoria || "",
    codigoBarras: produto.codigoBarras || "",
    estoque: Number(produto.estoque || 0),
    limiteAlerta: Number(produto.limiteAlerta || 12),
    custo: Number(produto.custo || 0),
    precoVenda: Number(produto.precoVenda || 0),
    unidade: produto.unidade || "un",
    criadoEm: agora,
    atualizadoEm: agora,
    ultimaSaidaEm: null,
  });
}

export async function atualizarProduto(uid, produtoId, dados) {
  const payload = {
    ...dados,
    atualizadoEm: new Date().toISOString(),
  };

  if (payload.estoque !== undefined) {
    payload.estoque = Number(payload.estoque || 0);
  }

  if (payload.limiteAlerta !== undefined) {
    payload.limiteAlerta = Number(payload.limiteAlerta || 12);
  }

  if (payload.custo !== undefined) {
    payload.custo = Number(payload.custo || 0);
  }

  if (payload.precoVenda !== undefined) {
    payload.precoVenda = Number(payload.precoVenda || 0);
  }

  await updateDoc(produtoDocRef(uid, produtoId), payload);
}

export async function excluirProduto(uid, produtoId) {
  await deleteDoc(produtoDocRef(uid, produtoId));
}

export async function registrarMovimentacao(uid, movimentacao) {
  const agora = new Date().toISOString();

  await addDoc(movimentacoesColRef(uid), {
    produtoId: movimentacao.produtoId || "",
    nomeProduto: movimentacao.nomeProduto || "",
    tipo: movimentacao.tipo || "",
    quantidade: Number(movimentacao.quantidade || 0),
    estoqueAntes: Number(movimentacao.estoqueAntes || 0),
    estoqueDepois: Number(movimentacao.estoqueDepois || 0),
    origem: movimentacao.origem || "manual",
    receitaId: movimentacao.receitaId || "",
    receitaNome: movimentacao.receitaNome || "",
    observacao: movimentacao.observacao || "",
    dataCompleta: agora,
    dia: agora.slice(0, 10),
    mes: agora.slice(0, 7),
  });
}

export async function registrarVenda(uid, venda) {
  const agora = new Date().toISOString();

  await addDoc(vendasColRef(uid), {
    produtoId: venda.produtoId || "",
    receitaId: venda.receitaId || "",
    nomeProduto: venda.nomeProduto || "",
    quantidade: Number(venda.quantidade || 0),
    valorUnitario: Number(venda.valorUnitario || 0),
    valorVenda: Number(venda.valorVenda || 0),
    lucroEstimado: Number(venda.lucroEstimado || 0),
    custoTotal: Number(venda.custoTotal || 0),
    origem: venda.origem || "manual",
    observacao: venda.observacao || "",
    dataCompleta: agora,
    dia: agora.slice(0, 10),
    mes: agora.slice(0, 7),
  });
}

export async function adicionarReceita(uid, receita) {
  const agora = new Date().toISOString();

  await addDoc(receitasColRef(uid), {
    nome: receita.nome || "",
    precoVenda: Number(receita.precoVenda || 0),
    ingredientes: Array.isArray(receita.ingredientes)
      ? receita.ingredientes.map((item) => ({
          insumoId: item.insumoId || "",
          quantidade: Number(item.quantidade || 0),
        }))
      : [],
    criadoEm: agora,
    atualizadoEm: agora,
  });
}

export async function atualizarReceita(uid, receitaId, dados) {
  const payload = {
    ...dados,
    atualizadoEm: new Date().toISOString(),
  };

  if (payload.precoVenda !== undefined) {
    payload.precoVenda = Number(payload.precoVenda || 0);
  }

  if (payload.ingredientes && Array.isArray(payload.ingredientes)) {
    payload.ingredientes = payload.ingredientes.map((item) => ({
      insumoId: item.insumoId || "",
      quantidade: Number(item.quantidade || 0),
    }));
  }

  await updateDoc(receitaDocRef(uid, receitaId), payload);
}

export async function excluirReceita(uid, receitaId) {
  await deleteDoc(receitaDocRef(uid, receitaId));
}